/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AbandonPOSCheckInRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {AbandonPOSCheckInResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const abandonPOSCheckIn = (request: AbandonPOSCheckInRequest, options?: CashRequestOptions) => post<AbandonPOSCheckInRequest, AbandonPOSCheckInResponse>("/2.0/cash/abandon-p-o-s-check-in", request, {...options, rejectOnError: true })